import { forwardRef } from 'react';

// Shared sticky-offset classes so no page hardcodes its own pin offset.
//
// TOP_BAR_STICKY: pins flush at the very top (offsetTop 0, zero pre-pin
// travel). Used by Layout's own logo bar, and by standalone pages with no
// Layout logo bar above them (e.g. MasterDataManagement's admin header).
export const TOP_BAR_STICKY = 'sticky top-0 z-40 bg-white border-b border-zinc-200';

// BELOW_LOGO_BAR_STICKY: pins directly below Layout's logo bar (top-20 under
// the mobile fixed header, top-14 under the desktop sticky bar). Reused by
// Dashboard, NewProcurement, and ContinueProcurement so every page's pinned
// row lines up under the same offset and z-index.
export const BELOW_LOGO_BAR_STICKY = 'sticky top-20 lg:top-14 z-30 bg-white border-b border-zinc-200';

export const StickyBar = forwardRef(({ className = '', children }, ref) => (
  <div ref={ref} className={`${BELOW_LOGO_BAR_STICKY} ${className}`}>
    {children}
  </div>
));
StickyBar.displayName = 'StickyBar';

export default StickyBar;
